import React, { useEffect, useState } from 'react'
import { GameBoardContainer } from './GameBoardStyles'
import { GameBoard_Props } from './interface'
import { calculateDelay } from './helpers/calculateDelay'
import RiverContainer from './RiverContainer'
import DealerContainer from './DealerContainer'
import PlayerContainer from './PlayerContainer'
import { useGameBoardSounds } from './helpers/gameBoardSounds'

function GameBoard({
  dealOut,
  deal,
  showResult,
  noAnimate,
  dealer,
  player,
  river,
  flipCard,
  dealRiver,
  audio,
  gameState,
  winPositions,
  showLoader,
}: GameBoard_Props) {
  const [dealedCards, setdealedCards] = useState<number>(0)
  const sfxs = useGameBoardSounds(audio?.volume)
  const isFold = gameState === 6 && dealer[0] !== 'X0'

  useEffect(() => {
    if (deal && !dealOut) {
      if (gameState === 4) {
        timerFunc(7)
      }
      if (gameState === 5) {
        timerFunc(2)
      }
    }
    if (dealOut) {
      timerFunc(3, 150)
    }
  }, [gameState, deal, dealOut])

  useEffect(() => {
    flipCard && audio?.sound && sfxs.playcardFlipSFX()
  }, [flipCard])

  useEffect(() => {
    !showLoader && deal && audio?.sound && sfxs.playcardDealSFX()
    dealOut && audio?.sound && player[0] !== 'X0' && sfxs.playcardClearSFX()
  }, [dealedCards])

  useEffect(() => {
    if (showResult && audio?.sound) {
      setTimeout(() => {
        if (gameState === 5) {
          sfxs.playWinSFX()
        }
        if (isFold) {
          sfxs.playLoseSFX()
        }
      }, 400)
    }
  }, [showResult, gameState])

  const timerFunc = (counter: number, delay?: number) => {
    const intervalTime = delay ? delay : 310
    const cardsSum = counter
    let x = 0
    const soundInterval = setInterval(() => {
      x++
      setdealedCards(x)
      if (x >= cardsSum) {
        clearInterval(soundInterval)
        return
      }
    }, intervalTime)
  }

  return (
    <GameBoardContainer>
      <DealerContainer
        cardsList={dealer}
        deal={deal}
        dealOut={dealOut}
        dealRiver={dealRiver}
        flipCard={flipCard}
        calculateDelay={calculateDelay}
        showResult={showResult}
        winPositions={winPositions.slice(7, 9)}
        noAnimate={noAnimate}
        delay={500}
      />
      <RiverContainer
        cardsList={river}
        deal={deal}
        dealRiver={dealRiver}
        dealOut={dealOut}
        calculateDelay={calculateDelay}
        showResult={showResult}
        winPositions={winPositions.slice(2, 7)}
        noAnimate={noAnimate}
        delay={250}
      />
      <PlayerContainer
        cardsList={player}
        deal={deal}
        dealOut={dealOut}
        calculateDelay={calculateDelay}
        showResult={showResult}
        winPositions={winPositions.slice(0, 2)}
        noAnimate={noAnimate}
      />
    </GameBoardContainer>
  )
}

export default GameBoard
